export default class Services {
    constructor() {
        this.initListeners();
    }

    initListeners() {
        document.addEventListener('click', (e) => {
            if(e.target && e.target.id !== 'cl_widget_links'){
                let clWidgetLinksBlock = document.getElementById('cl_widget_links_block');
                if (clWidgetLinksBlock && clWidgetLinksBlock.style.display === 'block') {
                    clWidgetLinksBlock.style.display = 'none';
                }
            }
        })
    }
}
